<template>
  <div class="flex flex-col sticky top-20 w-full h-0 gap-[10px] z-50">
    <div
        v-for="(toast, index) in toasts"
        :key="index"
        :class="[
        'relative flex flex-row py-[18px] px-[9px] pl-[100px] rounded',
        toastStyles[toast.type].background,
      ]"
    >
      <button
          class="absolute top-0 left-0 group w-7 h-7 flex justify-center items-center rounded"
          @click="closeToast(toast)"
      >
        <span
            :class="[
            'material-symbols-rounded text-xl',
            toastStyles[toast.type].closeIcon,
          ]"
        >close</span
        >
      </button>
      <p :class="['text-base font-bold', toastStyles[toast.type].text]">
        <span v-html="getMessage(toast)"></span>
      </p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "ToastNotifications",
  methods: {
    ...mapActions({
      closeToast: "orderToast/closeToast",
    }),
    getMessage(toast) {
      return this.toastMessages[toast.type](toast);
    },
  },
  computed: {
    ...mapState({
      toasts: (state) => state.orderToast.toasts,
    }),
  },
  data() {
    return {
      toastStyles: {
        update: {
          background: "bg-complementary-300",
          closeIcon: "text-primary-700",
          text: "text-complementary-900",
        },
        add: {
          background: "bg-complementary-300",
          closeIcon: "text-primary-700",
          text: "text-complementary-900",
        },
        danger: {
          background: "bg-error",
          closeIcon: "text-white",
          text: "text-white",
        },
        error: {
          background: "bg-error",
          closeIcon: "text-white",
          text: "text-white",
        },
        success: {
          background: "bg-success",
          closeIcon: "text-white",
          text: "text-white",
        },
      },
      toastMessages: {
        update: (toast) =>
            ` ${toast.message} ` + ` התעדכן בהצלחה ל${toast.amount}`,
        add: (toast) => "הוספתם " + ` ${toast.message} ` + `לסל המשפחתי שלכם. `,
        danger: (toast) => ` ${toast.message} ` + ` הוסר בהצלחה`,
        error: (toast) => `${toast.message} ` + `שגיאה`,
        success: (toast) => ` ${toast.message} `,
      },
    };
  },
};
</script>

<style scoped>
/* Add any additional styles if necessary */
</style>
